import axios from '@/libs/api.request'

export const getDefaultMarginSettings = () => {
  return axios.request({
    url: 'quotes/margin-settings',
    method: 'get'
  })
}

export const saveMarginSettings = (quoteId, data) => {
  return axios.request({
    url: `quotes/${quoteId}/margin-settings`,
    method: 'post',
    data
  })
}

export const getMarginSettings = (quoteId) => {
  return axios.request({
    url: `quotes/${quoteId}/margin-settings`,
    method: 'get'
  })
}

export const getCosts = (quoteId) => {
  return axios.request({
    url: `quotes/${quoteId}/margin/setting`,
    method: 'get'
  })
}

export const saveCosts = (quoteId, data) => {
  return axios.request({
    url: `quotes/${quoteId}/margin/setting`,
    method: 'post',
    data
  })
}

export const getMarginSummary = (quoteId) => {
  return axios.request({
    url: `quotes/${quoteId}/margin/summary`,
    method: 'get'
  })
}

export const getMarginBreakdowns = (quoteId) => {
  return axios.request({
    url: `quotes/${quoteId}/margin-breakdowns/with-latest-costs`,
    method: 'get'
  })
}

export const saveMarginBreakdowns = (quoteId, data) => {
  return axios.request({
    url: `quotes/${quoteId}/margin-breakdowns/batch`,
    method: 'post',
    data
  })
}

export const createCosts = (quoteId, data) => {
  return axios.request({
    url: `quotes/${quoteId}/costs/new`,
    method: 'post',
    data
  })
}

export const getCostSummary = (quoteId) => {
  return axios.request({
    url: `quotes/${quoteId}/cost/summary`,
    method: 'get'
  })
}

export const getCostQuantity = (cost_estimator_id) => {
  return axios.request({
    url: `/part-costs/${cost_estimator_id}`,
    method: 'get'
  })
}

export const getMarginBreakDetail = (quoteId, reportName) => {
  return axios.request({
    url: `/quotes/${quoteId}/margin-breakdowns/${reportName}`,
    method: 'get'
  })
}

export const getMarginSnapshots = (quoteId) => {
  return axios.request({
    url: `/quotes/${quoteId}/margin-snapshots`,
    method: 'get'
  })
}

export const getMarginSnapshotsById = (quoteId, snapshotId) => {
  return axios.request({
    url: `/quotes/${quoteId}/margin-snapshots/${snapshotId}`,
    method: 'get'
  })
}
